import React, { useMemo } from 'react';
import { Form, Select } from 'antd';
import { useGetManyWarehouses } from 'api/warehouses/use-get-many-warehouses.ts';
import { transformWarehousesForForm } from 'shared/utils/warehouses/transform-warehouses-for-form.ts';
import type { IWarehouseFormSelectProps } from './types';

export const WarehouseFormSelect: React.FC<IWarehouseFormSelectProps> = (props) => {
  const {
    name,
    rules,
    placeholder,
    label,
    className,
    rootClassName,
    disabled,
    handleChange,
    initialValue,
    mode = undefined,
    allowClear = true,
    internalOnly = false,
    withDeprecated = true,
    warehouseType,
  } = props;
  const { data: warehouse } = useGetManyWarehouses({ withDeprecated, internalOnly, type: warehouseType });

  const transformedWarehouse = useMemo(
    () => transformWarehousesForForm(warehouse, initialValue),
    [warehouse, initialValue],
  );

  return (
    <Form.Item name={name} label={label} className={className} rootClassName={rootClassName} rules={rules}>
      <Select
        optionFilterProp='label'
        placeholder={placeholder}
        options={transformedWarehouse}
        disabled={disabled}
        mode={mode}
        allowClear={allowClear}
        showSearch
        onChange={handleChange}
      />
    </Form.Item>
  );
};
